import { BxlAnalytics } from 'bxl-analytics'
import bxlbridge from 'bxl-bridge';
import { BXL_USER_ID, BXL_GUEST_ID, dogfoodPath, prodPath } from './constants'
import bxlutils from 'bxl-utils'
import { platform as getPlatform, MiniBridge, PLATFORM } from 'bxl-miniParse';
export const tracker = new BxlAnalytics({
    prodPath: prodPath(),
    dogfoodPath: dogfoodPath()
})
if (process.env.REACT_APP_BASE_ENV === 'dev') {
    tracker.useDogfoodApi(true)
}

// impression?.attach();

tracker?.registerSuperProperties({
    version: '1.0.0',
    appVersion: '',
    platform: () => {
        return `H5_Search_${bxlutils.platform.getOS()}/${bxlutils.platform.getVersion()}`
    },
    userId: () => {
        return localStorage.getItem(BXL_USER_ID) || ''
    },
    guestId: () => {
        return new Promise((res) => {
            getPlatform((platform: any) => {
                if(platform === PLATFORM.IN_APP) {
                    bxlbridge.invoke('getMetaInfo', {}, (result) => {
                        try {
                            const guestId = result.guest_id;
                            guestId && localStorage.setItem(BXL_GUEST_ID, guestId || '');
                            if(result && guestId) {
                                res(guestId)
                            } else {
                                res(localStorage.getItem(BXL_GUEST_ID) || '');
                            }
                        } catch (e) {}
                      });
                } else if(platform === PLATFORM.WECHAT_MINI || platform === PLATFORM.ALIPAY_MINI) {
                    MiniBridge.invoke('getSession', {}, (resp: any) => {
                        const { guestId } = resp;
                        guestId && localStorage.setItem(BXL_GUEST_ID, guestId || '');
                        if(resp && guestId) {
                            res(guestId)
                        } else {
                            res(localStorage.getItem(BXL_GUEST_ID) || '');
                        }
                    })
                } else {
                    res(localStorage.getItem(BXL_GUEST_ID) || '');
                }
            });
        })
    }
})
